<template>

  <div>

    <v-text-field

      :label="inputLabel"

      :value="computedAddressText"

      @click="open"

      outlined

      dense

      hide-details

      readonly

    ></v-text-field>



    <v-dialog v-model="dialog" max-width="600" persistent eager>

      <v-card>

        <v-card-title>{{ inputLabel }}</v-card-title>

        <v-card-text>

          <v-autocomplete

            v-model="selectedAddress"

            :label="`Busque pelo endereço`"

            :items="addressSearchList.length > 0 ? addressSearchList : [{ _template: true }]"

            :search-input.sync="searchInput"

            :filter="() => true"

            return-object

            item-text="name"

            outlined

            dense

            :loading="loading"

            hide-details

            hide-no-data

            hide-selected

            :item-disabled="item => item._template"

          >

            <template v-slot:selection="{ item }">

              {{ item.name }}

              <small v-if="item.description" class="text--secondary ml-2">{{

                item.description

              }}</small>

            </template>

            <template v-slot:item="{ item }">

              <v-list-item-content v-if="!item._template">

                <v-list-item-title>{{ item.name }}</v-list-item-title>

                <v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle>

              </v-list-item-content>

              <div v-else>

                <v-list-item-title>Digite para pesquisar um endereço</v-list-item-title>

              </div>

            </template>

          </v-autocomplete>

          <v-divider class="my-4"></v-divider>

          <v-alert v-if="!selectedAddress" type="warning" text>

            Primeiro, busque pelo endereço e selecione um dos resultados.

          </v-alert>

          <v-form v-model="valid" @submit.prevent>

            <v-row dense class="mx-0">

              <v-col cols="12" sm="8">

                <v-text-field

                  v-model="address.street"

                  label="Rua"

                  outlined

                  :disabled="!addressFieldsEnabled"

                  dense

                  hide-details

                  :rules="[requiredRule('Rua')]"

                ></v-text-field>

              </v-col>

              <v-col cols="12" sm="4">

                <v-text-field

                  v-model="address.number"

                  label="Número"

                  outlined

                  :disabled="!addressFieldsEnabled"

                  dense

                  hide-details

                  :rules="[requiredRule('Número')]"

                ></v-text-field>

              </v-col>

              <v-col cols="12" sm="6">

                <v-text-field

                  v-model="address.complement"

                  label="Complemento"

                  outlined

                  :disabled="!addressFieldsEnabled"

                  dense

                  hide-details

                ></v-text-field>

              </v-col>

              <v-col cols="12" sm="6">

                <v-text-field

                  v-model="address.district"

                  label="Bairro"

                  outlined

                  :disabled="!addressFieldsEnabled"

                  dense

                  hide-details

                  :rules="[requiredRule('Bairro')]"

                ></v-text-field>

              </v-col>

              <v-col cols="12" sm="4">

                <v-text-field

                  v-model="address.zipCode"

                  label="CEP"

                  outlined

                  :disabled="!addressFieldsEnabled"

                  dense

                  hide-details

                  :rules="[requiredRule('CEP')]"

                ></v-text-field>

              </v-col>

              <v-col cols="12" sm="4">

                <v-text-field

                  v-model="address.city"

                  label="Cidade"

                  outlined

                  :disabled="!addressFieldsEnabled"

                  dense

                  hide-details

                  :rules="[requiredRule('Cidade')]"

                ></v-text-field>

              </v-col>

              <v-col cols="12" sm="4">

                <v-text-field

                  v-model="address.state"

                  label="Estado"

                  outlined

                  :disabled="!addressFieldsEnabled"

                  dense

                  hide-details

                  :rules="[requiredRule('Estado')]"

                ></v-text-field>

              </v-col>

            </v-row>

          </v-form>

        </v-card-text>

        <v-card-actions>

          <v-btn text @click="close">Cancelar</v-btn>

          <v-spacer></v-spacer>

          <v-btn color="primary" @click="saveAddress" :disabled="!valid">Confirmar</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

  </div>

</template>

<script>

const { VUE_APP_MAPS_TOKEN } = process.env

let googleMapsPromise = null

function loadGoogleMaps() {
  if (window.google?.maps?.places) {
    return Promise.resolve(window.google)
  }

  if (!googleMapsPromise) {
    googleMapsPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = `https://maps.googleapis.com/maps/api/js?key=${VUE_APP_MAPS_TOKEN}&libraries=places&language=pt-BR`
      script.async = true
      script.onload = () => resolve(window.google)
      script.onerror = reject
      document.head.appendChild(script)
    })
  }

  return googleMapsPromise
}



export default {

  props: {

    value: {

      type: Object,

      default: null,

    },

    defaultValue: {

      type: String,

      default: null,

    },

    inputLabel: {

      type: String,

      default: 'Endereço Completo',

    },

    selectLabel: {

      type: String,

      default: 'Escolha o abaixo:',

    },

    resultLength: {

      type: Number,

      default: 5,

    },

    autoRun: {

      type: Boolean,

      default: false,

    },

    selectFirst: {

      type: Boolean,

      default: false,

    },

    resultsBg: {

      type: String,

      default: 'light',

    },

  },

  data() {

    return {

      addressSearchList: [],

      selectedAddress: null,

      randomId: null,

      loading: false,

      dialog: false,

      valid: false,

      searchTimeout: null,

      searchInput: '',

      autocomplete: null,

      places: null,

      requiredRule: lable => v => !!v || `${lable} é obrigatório`,

      address: {

        street: '',

        number: '',

        district: '',

        complement: '',

        city: '',

        state: '',

        country: 'Brasil',

        zipCode: '',

        lat: '',

        lng: '',

      },

    }

  },



  methods: {

    async initGoogleMaps() {
      const google = await loadGoogleMaps()

      this.autocomplete = new google.maps.places.AutocompleteService()

      this.places = new google.maps.places.PlacesService(

        new google.maps.Map(document.createElement('div'), {})

      )

    },

    runSearch(val) {

      if (!this.autocomplete) return



      this.autocomplete.getPlacePredictions(

        {

          input: val,

          language: 'pt-BR',

          componentRestrictions: { country: 'br' },

        },

        this.displaySuggestions

      )

    },

    displaySuggestions(predictions, status) {

      this.loading = false

      if (status !== window.google.maps.places.PlacesServiceStatus.OK) {

        this.addressSearchList = []

        return

      }



      this.addressSearchList = predictions.map(prediction => ({

        name: prediction.structured_formatting.main_text,

        description: prediction.structured_formatting.secondary_text,

        placeId: prediction.place_id,

      }))



      if (this.selectFirst && this.addressSearchList.length > 0) {

        this.selectedAddress = this.addressSearchList[0]

      }

    },

    fetchPlaceDetails(placeId) {

      if (!this.places) return



      this.loading = true

      this.places.getDetails(

        {

          language: 'pt-BR',

          placeId,

          fields: ['address_component', 'geometry', 'formatted_address'],

        },

        (place, status) => {

          this.loading = false

          if (status !== window.google.maps.places.PlacesServiceStatus.OK) return



          this.selectedAddress = {

            name: place.formatted_address,

            description: '',

            ...place,

          }

          this.address = this.decomposeAddress(place)

        }

      )

    },

    scheduleSearch() {

      if (!this.searchInput || typeof this.searchInput !== 'string') {

        this.loading = false

        return

      }

      if (this.searchInput.trim().length < 3) {

        this.loading = false

        return

      }



      this.loading = true

      clearTimeout(this.searchTimeout)

      this.searchTimeout = setTimeout(() => this.runSearch(this.searchInput), 500)

    },

    decomposeAddress(address) {

      const location = address.geometry?.location

      const lat = typeof location?.lat === 'function' ? location.lat() : location?.lat

      const lng = typeof location?.lng === 'function' ? location.lng() : location?.lng



      return {

        street:

          this.getAddressComponent(address, 'route') ||

          this.getAddressComponent(address, 'route', 'long_name') ||

          this.address.street,

        number: this.getAddressComponent(address, 'street_number', 'long_name') || this.address.number,

        district:

          this.getAddressComponent(address, 'sublocality_level_1', 'long_name') ||

          this.getAddressComponent(address, 'sublocality', 'long_name') ||

          this.address.district,

        complement:

          this.getAddressComponent(address, 'subpremise', 'long_name') || this.address.complement,

        city:

          this.getAddressComponent(address, 'administrative_area_level_2', 'long_name') ||

          this.address.city,

        state:

          this.getAddressComponent(address, 'administrative_area_level_1') || this.address.state,

        country:

          this.getAddressComponent(address, 'country', 'long_name') || this.address.country,

        zipCode: this.getAddressComponent(address, 'postal_code', 'long_name') || this.address.zipCode,

        lat,

        lng,

      }

    },

    getAddressComponent(address, type, key = 'short_name') {

      return address.address_components?.find(component => component.types.includes(type))?.[key]

    },

    open() {

      this.dialog = true

      if (this.computedAddressText) {

        this.address = Object.assign({}, this.address, this.value)

        this.selectedAddress = {

          name: this.computedAddressText,

          description: '',

        }

        this.$nextTick(() => {

          this.searchInput = this.computedAddressText

        })

      }

    },

    close() {

      this.dialog = false

      this.searchInput = ''

      this.addressSearchList = []

      this.selectedAddress = null

      this.address = {

        street: '',

        number: '',

        district: '',

        complement: '',

        city: '',

        state: '',

        country: 'Brasil',

        zipCode: '',

        lat: '',

        lng: '',

      }

    },

    saveAddress() {

      this.$emit('input', this.address)

      this.close()

    },

  },

  watch: {

    searchInput() {

      this.scheduleSearch()

    },

    selectedAddress(val) {

      if (!val || val._template) return

      if (val.placeId) {

        this.fetchPlaceDetails(val.placeId)

        return

      }

      if (val.address_components) {

        this.address = this.decomposeAddress(val)

      }

    },

  },

  computed: {

    addressFieldsEnabled() {

      if (!this.selectedAddress) return false

      if (this.selectedAddress.placeId && this.loading) return false

      return !!(this.selectedAddress.address_components || this.address.street)

    },

    computedAddressText() {

      if (!this.value) return ''

      const components = [

        `${this.value.street}, ${this.value.number}`,

        this.value.district,

        this.value.city,

        this.value.state,

      ].filter(Boolean)

      return components.join(' - ')

    },

  },

  mounted() {

    this.initGoogleMaps()

    this.randomId = Math.random().toString(36).substring(7)

  },

}

</script>



<style></style>

